import { render, staticRenderFns } from "./toggle.vue?vue&type=template&id=be786480&"
import script from "./toggle.vue?vue&type=script&lang=js&"
export * from "./toggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\gw-actions-runner\\_work\\gower-web-core\\gower-web-core\\App.Core.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be786480')) {
      api.createRecord('be786480', component.options)
    } else {
      api.reload('be786480', component.options)
    }
    module.hot.accept("./toggle.vue?vue&type=template&id=be786480&", function () {
      api.rerender('be786480', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "scripts/components/generic/toggle.vue"
export default component.exports